export const getObjectKey = (object, value) => {
    return Object.keys(object).find((key) => object[key] === value)
}

export const getObjectValue = (object, key, ignoreCase = true) => {
    if (!key) return undefined
    if (ignoreCase === true)
        key = Object.keys(platforms).find(
            (x) => x.toLowerCase() === key.toLowerCase()
        )
    return platforms[key]
}

export const statusTypes = {
    Error: 1,
    Activated: 2,
    Redirected: 3,
    Registered: 4,
    CustomerDisabled: 5,
    PendingValidation: 7,
}

export const entryTypeIds = {
    reservationEvent: 1,
    incidence: 2,
    courierEvent: 3,
    externalHauler: 4
}

export const orderTypes = {
    eCommerce: 1,
    noPlatform: 2,
    dispatch: 3,
    reverseLogistic: 4,
}

export const reservationCancellationResults = {
    cancelled: 1,
    canNotBeCancelled: 2,
    waitingIncidenceResolution: 3,
}

export const orderStateTypes = {
    registered: 1,
    pendingIncidentResolution: 2,
    reserved: 3,
    waitingPickup: 4,
    pendingReservation: 5,
    customerPickup: 6,
    abandoned: 7,
    abandonedCollected: 8,
    deposited: 9,
    depositExpired: 10,
    parcelCollected: 11,
    inFacility: 12,
    inTransit: 13,
    cancelled: 20,
    expired: 21,
    pendingPayment: 22,
    paid: 23,
    returnToSender: 24,
    outForDelivery: 25,
    courierDelivered: 26,
    lockerPickup: 27,
    unableToPickup: 28,
    orderWaitingPickUpLimit: 99,
}

export const platforms = {
    noPlatform: 0,
    shopify: 1,
    tiendaNube: 2,
    wooCommerce: 3,
    justPudo: 4,
    billowShop: 5,
}

export const externalHaulerStates = {
    ShipmentCreated: 1,
    ShippingWithdrawn: 2,
    ShippingSupported: 3,
    ShipmentProcessed: 4,
    ShippingInTransitToTheDestinationBranch: 5,
    ShipmentReceivedAtDestinationBranch: 6,
    ShipmentAwaitingPickupAtBranch: 7,
    ShippingScheduledForVisit: 8,
    StreetDelivery: 9,
    ShipmentDelivered: 10,
    ShipmentNotDelivered: 11,
    ReturnShipping: 12
}

export const reservationStates = {
    new: 1,
    canceled: 2,
    expiredNotConfirmed: 3,
    confirmed: 4,
    expiredNotDeposited: 5,
    canceledNotDeposited: 6,
    deposited: 7,
    canceledDeposited: 8,
    canceledDepositedCollected: 9,
    expiredNotCollected: 10,
    collected: 11,
    abandoned: 12,
    abandonedCollected: 13,
    canceledParcelMissing: 14,
}

export const eventTypes = {
    newLockerConfiguration: 1,
    reservationConfirmed: 2,
    reservationDeposited: 3,
    reservationCollected: 4,
    reservationDepositWhenNotIdle: 5,
    reservationDepositAbandoned: 6,
    reservationDepositExpired: 7,
    reservationDepositDoorLocked: 8,
    reservationDepositPackageFound: 9,
    reservationDepositDoorOpenedAndPackageNotFound: 10,
    reservationDepositDoorOpenedAndPackageFound: 11,
    reservationPickupCompleted: 12,
    reservationPickupExpired: 13,
    reservationPickupWhenNotIdle: 14,
    reservationPickupDoorLocked: 15,
    reservationPickupPackageMissing: 16,
    reservationPickupDoorOpenedAndPackageNotFound: 17,
    reservationPickupDoorOpenedAndPackageFound: 18,
    reservationDepositTimerExpired: 19,
    reservationDepositTimerExpiresSoon: 20,
    reservationPickupTimerExpired: 21,
    reservationPickupTimerExpiresSoon: 22,
    reservationParcelMissing: 23,
    reservationCancellationRequest: 24,
    reservationCancellationResult: 25,
    reservationAbandoned: 26,
    reservationCollectedByTechnician: 27,
    reservationAbandonedCollected: 28,
    reservationAbandonedPickupCompleted: 29,
    reservationAbandonedPickupExpired: 30,
    reservationAbandonedPickupWhenNotIdle: 31,
    reservationAbandonedPickupDoorLocked: 32,
    reservationAbandonedPickupPackageMissing: 33,
    reservationAbandonedPickupDoorOpenedAndPackageNotFound: 34,
    reservationAbandonedPickupDoorOpenedAndPackageFound: 35,
    reservationPickupInvalidSecurityCode: 40,
    newServiceAccessConfiguration: 100,
    technicianLogin: 101,
    technicianLogout: 102,
    technicianOpenDoor: 103,
    technicianOpenDoorRequested: 104,
    technicianOpenDoorRequestTimedOut: 105,
    technicianStatusChangedDoorOpenedPackagePresent: 106,
    technicianStatusChangedDoorOpenedPackageNotPresent: 107,
    technicianStatusChangedDoorClosedPackagePresent: 108,
    technicianStatusChangedDoorClosedPackageNotPresent: 109,
    expectedStatusChanged: 200,
    expectedStatusOpeningDoor: 201,
    inconsistencyDetectedDoorNotFound: 300,
    inconsistencyDetectedReservationPackageMissing: 301,
    inconsistencyDetectedReservationDoorOpened: 302,
    inconsistencyDetectedUnexpectedPackageFound: 303,
    inconsistencyDetectedDoorLeftOpened: 304,
    configurationParamUpdate: 400,
    lockerStateUpdate: 401,
    reservationExtended: 402,
    incidence: 500,
    depositOrPickupFailed: 45,
    reservationCancelled: 50,
    reservationCancelledCollected: 51,
    reservationCancelledPickupCompleted: 52,
    reservationCancelledPickupExpired: 53,
    reservationCancelledPickupWhenNotIdle: 54,
    reservationCancelledPickupDoorLocked: 55,
    reservationCancelledPickupPackageMissing: 56,
    reservationCancelledPickupDoorOpenedAndPackageNotFound: 57,
    reservationCancelledPickupDoorOpenedAndPackageFound: 58,
    recoverReservationRequest: 60,
    recoverReservationResult: 61,

    securityTokenGenerated: 70,
    securityTokenValid: 71,
    securityTokenInvalid: 72,

    expectedStatusDoorLocked: 202,
}

// CourierParcel Events
export const courierParcelEventTypeIds = {
    created: 1,
    markedForPickUp: 2,
    parcelPickUp: 3,
    arrivalAtFacility: 4,
    waitingReservation: 5,
    reserved: 6,
    expired: 7,
    cancelled: 8,
    waitingCourierConfirmation: 9,
    waitingIncidenceResolution: 10,
    inTransit: 11,
    departureFromFacility: 12,
    delivered: 13,
    deliverAttempt: 14,
    returnToSender: 15,
    outForDelivery: 16,
    pickupAttempt: 17,
    courierDeliver: 18,
    lockerPickup: 19,
    unableToPickup: 20,
    addressEditByCourier: 21,
}

export const shippingMethods = {
    standard: 1,
    instantPickup: 2,
    shipToAddress: 3,
}

export const collectionSecurityCodeTypes = {
    noSecurityCodePresent: 1,
    dni: 2,
    alphaNumeric: 3,
}
